import { api, makeApiRequest } from 'api/_init'
import { unwrapEnvelope } from 'domain/shared/envelope'
import { mapCampaignSetupsResponse, mapDefaultCampaignParameters, mapPublishedCampaignSetupsError } from './mappers'

const publishedCampaignSetupsApi = {
  fetchCampaignSetupsAsync: async (eventId) => {
    const response = await makeApiRequest(api, 'get', `/events/${eventId}/campaign_setups`)
    const { data, error, status } = unwrapEnvelope(response)
    if (status === 200) {
      return { data: mapCampaignSetupsResponse(data), status }
    }
    return { error: mapPublishedCampaignSetupsError(error, status), status }
  },

  fetchDefaultParametersAsync: async (eventId) => {
    const response = await makeApiRequest(api, 'get', `/events/${eventId}/default_campaigns_parameters`)
    const { data, error, status } = unwrapEnvelope(response)
    if (status === 200) {
      return { data: mapDefaultCampaignParameters(data), status }
    }
    return { error: mapPublishedCampaignSetupsError(error, status), status }
  },

  // Backend needs the full creative object even when unchanged, and answers 204
  // with no body — callers re-fetch via fetchCampaignSetupsAsync.
  //
  // `targeting` carries forward per platform key: an absent or falsy key keeps
  // that platform's previously published targeting, so `{}` cannot clear it. To
  // drop a field, send that platform's key with the remaining content.
  editPublishedTcAsync: async (eventId, { tc, tcRunId, creative, targeting }) => {
    const body = {
      eid: eventId,
      tc,
      tc_run_id: tcRunId,
      creative,
      ...(targeting ? { targeting } : {}),
    }
    const response = await makeApiRequest(api, 'post', '/campaigns_setup/', body)
    const { error, status } = unwrapEnvelope(response)
    if (status === 204) {
      return { status }
    }
    return { error: mapPublishedCampaignSetupsError(error, status), status }
  },

  // Merges per platform key, but Meta's live fan-out only fires when the `fb`
  // key is present — send every gated platform, not just what changed.
  updateCampaignTargetingAsync: async (eventId, campaignTargeting) => {
    const response = await makeApiRequest(api, 'patch', `/events/${eventId}/campaign_setups`, {
      campaign_targeting: campaignTargeting,
    })
    const { error, status } = unwrapEnvelope(response)
    if (status === 204) {
      return { status }
    }
    return { error: mapPublishedCampaignSetupsError(error, status), status }
  },
}

export default publishedCampaignSetupsApi
